import { useEffect } from "react";
import type { SceneCompletion, SceneId } from "../../../types/navigation";
import type { ActionCallsType } from "../../../services/actionCalls.ts";

type HookParams = {
  id: string | undefined;
  videoRef: React.RefObject<HTMLVideoElement> | null;
  onComplete: SceneCompletion | undefined;
  changeScene: (sceneId: SceneId) => void;
  onActionCall: ActionCallsType;
  seek: (time: number) => void;
};

export function useOnCompleteVideo({
  id,
  videoRef,
  onComplete = {},
  onActionCall,
  changeScene,
  seek,
}: HookParams) {
  function handleComplete() {
    if (!onComplete) return;
    const {
      loopTo = undefined,
      link = undefined,
      action = undefined,
    } = onComplete;

    if (typeof loopTo === "number") return seek(loopTo);
    if (typeof link === "string") return changeScene(link);
    if (action && action.name in onActionCall) {
      const actionFn = onActionCall[action.name as keyof ActionCallsType];
      return (actionFn as (...args: any[]) => void)(...action.args);
    }
  }

  useEffect(() => {
    console.log("Setting up onComplete for video:", id);

    if (videoRef?.current) {
      videoRef.current.addEventListener("ended", handleComplete);
    }

    return () => {
      if (videoRef?.current) {
        videoRef.current.removeEventListener("ended", handleComplete);
      }
    };
  }, [id]);
}
